import urls from 'constants/urls';

export const continueShoppingUrlSelector = state =>
  state.login.lastNonAuthenticationPath || urls.groceriesHome;
